import React from 'react'
import { useAgreementList } from '../../../../api/agreements/get-agreement-list'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { agreementListTableConfig } from './agreement-list-table-config'
import { Table, TTableRowAction } from '@reapitform/common-ui'
import { AgreementListItem } from '../../../../api/types/agreements'

export interface AgreementTableProps {
  rowActions?: TTableRowAction[]
  defaultStatus?: AgreementListItem['status']
  disableSelection?: boolean
}

export const AgreementTable: React.FC<AgreementTableProps> = ({ rowActions, defaultStatus, disableSelection }) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()

  const {
    data: agreementList,
    loading: loadingAgreementList,
    pagination,
  } = useAgreementList({
    query: searchParams.get('query'),
    pageNumber: Number(searchParams.get('pageNumber')),
    sortBy: searchParams.get('sortBy'),
    sortByDirection: searchParams.get('sortByDirection'),
    status: searchParams.get('filterByStatus') ?? defaultStatus,
  })

  const handlePageChanges = (newPage: number) => {
    setSearchParams((params) => {
      params.set('pageNumber', newPage.toString())
      return params
    })
  }

  const handleSortChanges = (key: string, order: 'asc' | 'desc') => {
    setSearchParams((params) => {
      params.set('sortBy', key)
      params.set('sortByDirection', order === 'asc' ? 'Ascending' : 'Descending')
      return params
    })
  }

  return (
    <Table<AgreementListItem>
      {...agreementListTableConfig}
      rowKeyIdentifier="referenceID"
      rows={agreementList}
      isLoading={loadingAgreementList}
      isRowSelectable={!disableSelection}
      pagination={pagination}
      onPageChange={handlePageChanges}
      tableRowAction={rowActions}
      onReorder={handleSortChanges}
      onRowClick={(rowData) => navigate(`${rowData.referenceID}/create`)}
    />
  )
}
